import { render, staticRenderFns } from "./MyWalletTotalBalanceCard.vue?vue&type=template&id=c649a3e8&scoped=true"
import script from "./MyWalletTotalBalanceCard.vue?vue&type=script&lang=ts"
export * from "./MyWalletTotalBalanceCard.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletTotalBalanceCard.vue?vue&type=style&index=0&id=c649a3e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c649a3e8",
  null
  
)

export default component.exports